import { Button, Modal, notification } from 'antd';
import AC from '../AccessControl';
import CTX from '../../lib/AssignmentsContext';
import { useContext } from 'react';
const AssignButton = ({
  assignment,
  playlist = false,
  ...buttonProps
}) => {
  const [notify, notifyCTX] = notification.useNotification();
  const {
    data,
    actions
  } = useContext(CTX);
  const assign = () => {
    const overwrite = () => {
      actions.reset();
      actions.addAssignments([assignment]);
      actions.setListPrepared(true);
    };
    if (data.assignments.length > 0) {
      Modal.confirm({
        content: <>
						Your playlist is not empty.
						<br />
						Are you sure you want to overwrite it?
					</>,
        onOk: overwrite
      });
    } else {
      overwrite();
    }
  };
  const addToPlaylist = () => {
    actions.addAssignments([assignment]);
    const taskLength = assignment.tasks.length;
    notify.success({
      placement: 'bottomRight',
      message: `Added ${taskLength} ${taskLength === 1 ? 'activity' : 'activities'} to the playlist.`,
      description: <AC.Link href={{
        pathname: '/toolkits/assignment-playlist'
      }} label="View" />
    });
  };
  return <>
			{notifyCTX}
			<Button {...buttonProps} onClick={playlist ? addToPlaylist : assign} children={playlist ? 'Add to Playlist' : 'Assign to Students'} data-sentry-element="Button" data-sentry-source-file="AssignButton.jsx" />
		</>;
};
export default AssignButton;